import React from 'react';
import ChevronRight from '@mui/icons-material/ChevronRight';
import { v4 } from 'src/helpers/uuid';
import Check from '@mui/icons-material/Check';
import { QUESTIONNAIRE_PAGE_URL } from 'src/constants/constants.js';
import urlParamsMapper from 'src/helpers/urlParamsMapper.js';

const statusClassNameMap = {
  Not_Visited: 'grey-back',
  CurrentNotComplete: 'gold-back',
  InComplete: 'gold-back',
  Complete: 'green-back',
  CurrentComplete: 'green-back',
};

export const QuestionnaireSectionItemsPres = ({ items, params, clickHandler }) => {
  if (!items || (items && items.length === 0)) {
    return null;
  }
  return (
    <div className="section-items">
      {items.map((item, index) => {
        const {
          // isDynamic,
          menuName,
          pageId,
          pageState,
        } = item;
        const pageURL = urlParamsMapper(QUESTIONNAIRE_PAGE_URL, {
          ...params,
          pageId,
        });
        return (
          <div className="section-devider" key={v4()}>
            <a
              key={v4()}
              className="section-item"
              href={pageURL}
              onClick={e => {
                e.preventDefault();
                clickHandler(pageURL);
              }}>
              <span className={`status-circle ${statusClassNameMap[pageState]}`}>
                {(pageState === 'Complete' || pageState === 'CurrentComplete') && <Check />}
              </span>
              <span className="section-item-name">{menuName}</span>
              <ChevronRight />
            </a>
          </div>
        );
      })}
    </div>
  );
};

export default QuestionnaireSectionItemsPres;
